 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c":"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c","Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3":"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3","Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage":"Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage","Account~crudDetail~groupSession~home~requests~singleSession":"Account~crudDetail~groupSession~home~requests~singleSession","Account":"Account","crudDetail":"crudDetail","home":"home","debriefing":"debriefing","feedback~sequence":"feedback~sequence","sequence":"sequence","moduleAdminPage~registerAdminPage~sequenceAdminPage":"moduleAdminPage~registerAdminPage~sequenceAdminPage","moduleAdminPage":"moduleAdminPage","registerAdminPage":"registerAdminPage","sequenceAdminPage":"sequenceAdminPage","assignmentSingleSession~groupSession~singleSession":"assignmentSingleSession~groupSession~singleSession","groupSession":"groupSession","singleSession":"singleSession","ChangePwd~login~registration":"ChangePwd~login~registration","ChangePwd":"ChangePwd","feedback~registration":"feedback~registration","registration":"registration","login":"login","assignmentSingleSession":"assignmentSingleSession","feedback":"feedback","pwdrecover":"pwdrecover","renew_pwd":"renew_pwd","requests":"requests","about":"about","admin":"admin","assignmentIntro":"assignmentIntro","beforestarting":"beforestarting","module":"module","notFound":"notFound","notSupported":"notSupported","overview":"overview","pwdvalidate":"pwdvalidate","session~taskDetail":"session~taskDetail","session":"session","taskDetail":"taskDetail","tipsOverview":"tipsOverview","transitionSession":"transitionSession"}[chunkId]||chunkId) + "." + {"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c":"88b3cf35","Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3":"6be167d0","Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage":"17b36001","Account~crudDetail~groupSession~home~requests~singleSession":"06c79e7e","Account":"088686b0","crudDetail":"8534ed49","home":"fac1d2bf","debriefing":"8834e1f4","feedback~sequence":"66c2b9e8","sequence":"56e12b0d","moduleAdminPage~registerAdminPage~sequenceAdminPage":"a8c8c21c","moduleAdminPage":"7905f4d1","registerAdminPage":"01127977","sequenceAdminPage":"3cd56239","assignmentSingleSession~groupSession~singleSession":"fb0dfa03","groupSession":"c17d1053","singleSession":"f9af20e0","ChangePwd~login~registration":"2d61751d","ChangePwd":"d2662f83","feedback~registration":"da879a12","registration":"99fbce75","login":"6d083620","assignmentSingleSession":"950fb1d9","feedback":"a9c24765","pwdrecover":"9e2aeb2b","renew_pwd":"62c6d65c","requests":"2a225724","about":"e7562f6c","admin":"d009eab1","assignmentIntro":"03db055a","beforestarting":"a82a5ce2","module":"a8311790","notFound":"02052c81","notSupported":"9d8e613b","overview":"0a883b56","pwdvalidate":"61be3633","session~taskDetail":"040f9c0c","session":"45d46409","taskDetail":"020fd614","tipsOverview":"5317b5c7","transitionSession":"7bc1c2f8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c":1,"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3":1,"Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage":1,"Account~crudDetail~groupSession~home~requests~singleSession":1,"Account":1,"crudDetail":1,"home":1,"debriefing":1,"feedback~sequence":1,"sequence":1,"moduleAdminPage~registerAdminPage~sequenceAdminPage":1,"moduleAdminPage":1,"registerAdminPage":1,"assignmentSingleSession~groupSession~singleSession":1,"groupSession":1,"singleSession":1,"feedback~registration":1,"registration":1,"login":1,"assignmentSingleSession":1,"feedback":1,"requests":1,"assignmentIntro":1,"beforestarting":1,"module":1,"pwdvalidate":1,"session~taskDetail":1,"session":1,"taskDetail":1,"tipsOverview":1,"transitionSession":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c":"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c","Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3":"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3","Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage":"Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage","Account~crudDetail~groupSession~home~requests~singleSession":"Account~crudDetail~groupSession~home~requests~singleSession","Account":"Account","crudDetail":"crudDetail","home":"home","debriefing":"debriefing","feedback~sequence":"feedback~sequence","sequence":"sequence","moduleAdminPage~registerAdminPage~sequenceAdminPage":"moduleAdminPage~registerAdminPage~sequenceAdminPage","moduleAdminPage":"moduleAdminPage","registerAdminPage":"registerAdminPage","sequenceAdminPage":"sequenceAdminPage","assignmentSingleSession~groupSession~singleSession":"assignmentSingleSession~groupSession~singleSession","groupSession":"groupSession","singleSession":"singleSession","ChangePwd~login~registration":"ChangePwd~login~registration","ChangePwd":"ChangePwd","feedback~registration":"feedback~registration","registration":"registration","login":"login","assignmentSingleSession":"assignmentSingleSession","feedback":"feedback","pwdrecover":"pwdrecover","renew_pwd":"renew_pwd","requests":"requests","about":"about","admin":"admin","assignmentIntro":"assignmentIntro","beforestarting":"beforestarting","module":"module","notFound":"notFound","notSupported":"notSupported","overview":"overview","pwdvalidate":"pwdvalidate","session~taskDetail":"session~taskDetail","session":"session","taskDetail":"taskDetail","tipsOverview":"tipsOverview","transitionSession":"transitionSession"}[chunkId]||chunkId) + "." + {"Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~cb92e56c":"6094d6b4","Account~ChangePwd~assignmentSingleSession~crudDetail~debriefing~feedback~groupSession~home~login~mod~c1c562c3":"fd35fbd7","Account~crudDetail~debriefing~home~moduleAdminPage~registerAdminPage~sequence~sequenceAdminPage":"665383eb","Account~crudDetail~groupSession~home~requests~singleSession":"71de997d","Account":"e5a949f6","crudDetail":"db894e86","home":"6e0195fc","debriefing":"c6fe3ff2","feedback~sequence":"6be90dbe","sequence":"a9beac52","moduleAdminPage~registerAdminPage~sequenceAdminPage":"daca5a6e","moduleAdminPage":"848fafb3","registerAdminPage":"848fafb3","sequenceAdminPage":"31d6cfe0","assignmentSingleSession~groupSession~singleSession":"fdc4811b","groupSession":"edd6ad90","singleSession":"a5bba32b","ChangePwd~login~registration":"31d6cfe0","ChangePwd":"31d6cfe0","feedback~registration":"0bb2e40d","registration":"c831a963","login":"a6def8d0","assignmentSingleSession":"f4fa7f4d","feedback":"6a180aca","pwdrecover":"31d6cfe0","renew_pwd":"31d6cfe0","requests":"e38ca40f","about":"31d6cfe0","admin":"31d6cfe0","assignmentIntro":"ac0ec223","beforestarting":"e6019666","module":"54a24d06","notFound":"31d6cfe0","notSupported":"31d6cfe0","overview":"31d6cfe0","pwdvalidate":"c4b12970","session~taskDetail":"db9ab3b1","session":"b7eb6c24","taskDetail":"294f3b01","tipsOverview":"36640b0d","transitionSession":"c4b12970"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
